module.exports = __webpack_public_path__ + "img/portrait-085.1958fb44.jpg";